import { Component, OnInit, TemplateRef, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { BaseComponent, UserService, AdminService } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-ai-assistant-config",
  templateUrl: "ai-assistant-config.component.html",
  standalone: false,
})
export class AiAssistantConfigComponent extends BaseComponent implements OnInit {
  @ViewChild("editConfigModal") editConfigModal: TemplateRef<any>;
  public loading: boolean = false;
  public saving: boolean = false;
  public configs: any[] = [];
  public editingConfig: any = {};
  public isNew: boolean = false;
  public modalTitle: string = "";

  constructor(
    userService: UserService,
    public adminService: AdminService,
    public appService: AppService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.loadConfigs();
  }

  loadConfigs() {
    this.loading = true;
    this.adminService.getAiAssistantConfigs().subscribe({
      next: (result: any) => {
        this.configs = result || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  addConfig() {
    this.isNew = true;
    this.modalTitle = "Add Config";
    this.editingConfig = {
      client_id: "",
      model: "",
      request_type: "",
      vector_store_id: "",
      max_output_tokens: 4096,
      search_links: [],
      classification_prompt: "",
      app_prompt: "",
      creative_prompt: "",
      oos_prompt: "",
      dev_prompt: "",
      daily_message_limit: null,
      daily_token_limit: null,
    };
    this.appService.showModal(this.editConfigModal, { size: "lg" });
  }

  editConfig(config: any) {
    this.isNew = false;
    this.modalTitle = "Edit Config";
    this.editingConfig = JSON.parse(JSON.stringify(config));
    this.appService.showModal(this.editConfigModal, { size: "lg" });
  }

  duplicateConfig(config: any) {
    this.isNew = true;
    this.modalTitle = "Duplicate Config";
    this.editingConfig = JSON.parse(JSON.stringify(config));
    this.editingConfig.request_type = "";
    this.appService.showModal(this.editConfigModal, { size: "lg" });
  }

  deleteConfig(config: any) {
    if (confirm(`Are you sure you want to delete the configuration for "${config.client_id} / ${config.model} / ${config.request_type}"?`)) {
      this.adminService.deleteAiAssistantConfig(config.client_id, config.model, config.request_type).subscribe({
        next: () => {
          this.loadConfigs();
        },
      });
    }
  }

  getSearchLinksString(): string {
    return (this.editingConfig.search_links || []).join("\n");
  }

  setSearchLinksFromString(value: string) {
    this.editingConfig.search_links = value
      .split(/[\n,]+/)
      .map((s: string) => s.trim())
      .filter((s: string) => !!s);
  }

  submit() {
    if (!this.editingConfig.client_id || !this.editingConfig.model || !this.editingConfig.request_type) return;
    this.saving = true;
    const save$ = this.isNew
      ? this.adminService.saveAiAssistantConfig(this.editingConfig)
      : this.adminService.updateAiAssistantConfig(this.editingConfig.client_id, this.editingConfig.model, this.editingConfig);

    save$.subscribe({
      next: () => {
        this.saving = false;
        this.appService.closeModals();
        this.loadConfigs();
      },
      error: () => {
        this.saving = false;
      },
    });
  }
}
